export const LOAD_COURSES = '[COURSES] LOAD_COURSES'
export const LOAD_THEME = '[COURSES] LOAD_THEME'
export const LOAD_QUESTIONS = '[COURSES] LOAD_QUESTIONS'
export const FINISHED_COURSE = '[COURSES] FINISHED_COURSE'
export const LOAD_NEXT_THEME = '[COURSES] LOAD_NEXT_THEME'
export const LOAD_PAYU_DATA_PURCHASE_ALL = '[COURSES] LOAD_PAYU_DATA_PURCHASE_ALL'
export const LOAD_RECOMMENDATION = '[COURSES] LOAD_RECOMMENDATION'
